var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-wrapper"},[_c('div',{staticClass:"spinner",style:(_vm.spinnerStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }